export const newsFlash = [
  {
    id: 1,
    tag: "开箱速报",
    time: "10月11日 09:20",
    title: "秋季限定「栗子核桃盒」首批到货，开箱即见整颗糖炒栗",
    excerpt:
      "本期 8 个单品里有 3 款是往年没出现过的秋季限定，糖炒栗、桂花糕与山核桃占据了整盒主线，甜度比夏季盒略低。",
  },
  {
    id: 2,
    tag: "试吃记录",
    time: "10月10日 20:45",
    title: "川香麻辣锅巴盲测：三种辣度里，中间那档最让人停不下嘴",
    excerpt:
      "我们把同一品牌的微辣、中辣、特辣各拆了一包做对比。特辣香而不燥，中辣的回甘最明显，微辣更偏咸香。",
  },
  {
    id: 3,
    tag: "惊喜发现",
    time: "10月09日 15:10",
    title: "拆到一颗包着牛皮纸的手工牛轧糖，附了手写小卡片",
    excerpt:
      "这是本月最意外的彩蛋：没有任何品牌标识，只有一句「慢慢吃」。糖体偏软，奶味重，夹的是烤过的夏威夷果。",
  },
  {
    id: 4,
    tag: "开箱速报",
    time: "10月08日 11:00",
    title: "怀旧时光盒补货，麦丽素、话梅糖、无花果丝重新回到清单",
    excerpt:
      "老式包装保留了蜡纸与纸盒质感，口味基本没改。试吃团反馈话梅糖的酸度比记忆中更收敛一些。",
  },
  {
    id: 5,
    tag: "试吃记录",
    time: "10月07日 19:30",
    title: "蜂蜜黄油杏仁与炭烤腰果同日开袋，香气走向完全不同",
    excerpt:
      "前者偏甜润，适合配茶；后者带明显焦香，咸度更高。两款都是独立小包装，适合分次吃完。",
  },
  {
    id: 6,
    tag: "科普",
    time: "10月06日 10:05",
    title: "盲盒里的「隐藏款」是怎么被放进盒子的？一次简单说明",
    excerpt:
      "隐藏款通常按更低比例混入，装箱时随机分配，不固定在某个位置，所以同一批盒子之间不会完全一样。",
  },
];